export class Paper {
    _id:string;
    createdAt:string;
    marks: number;
    status:string;
    paper: Paper;
    summary:string;
    title:string;
    paperSet: PaperSet; 
    clientStatus: string;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class PaperSet {
    _id:string;
    clientStatus:string;
    brandImage: string;
    brandName: string;
    // createdBy: NewUser;
    startAt: string;
    createdAt:string;
    price: number;
    relesedAt:string;
    accessLevel:string;
    resultReleaseAt: string;
    isOnlinePaper:boolean;
    status:string;
    summary:string;
    title:string;
    isResultsReleased: boolean;
    buttonStatus : string;
    buyButtonColor: string;
    paperSetType: string;
    // userInfo : UserInfo;
    constructor(values) {
        Object.assign(this, values);
        // this.userInfo = new UserInfo(values.userInfo);
        // this.createdBy = new NewUser(values.createdBy ? values.createdBy : {firstname: '', lastname : null});
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/paper.ts